var _circle, _rect, _rect2, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAuthRequ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#F3F6FB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 60,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#407EDB",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#FFE03B",
    fillOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 79V105M100 114V118",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAuthRequ);
export default __webpack_public_path__ + "static/media/icon_auth_requ.fab378d82b802b77b2588f971bd9514b.svg";
export { ForwardRef as ReactComponent };